/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SalesTotalsbyAmountService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { SalesTotalsbyAmountData, SalesTotalsbyAmountService } from './SalesTotalsbyAmount.service';
import { SalesTotalsbyAmountSearchComponent }  from './SalesTotalsbyAmountSearch.component';

@Component({
	selector: 'my-SalesTotalsbyAmount',
	template: require('./SalesTotalsbyAmountList.component.html'),
	providers: [SalesTotalsbyAmountService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SalesTotalsbyAmountListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	SalesTotalsbyAmountList: SalesTotalsbyAmountData[];
	newSalesTotalsbyAmount: SalesTotalsbyAmountData;
	selectedSalesTotalsbyAmount: SalesTotalsbyAmountData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(SalesTotalsbyAmountSearchComponent) filterComponent: SalesTotalsbyAmountSearchComponent;

	sortExpression: string = "SaleAmount";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private SalesTotalsbyAmountService: SalesTotalsbyAmountService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newSalesTotalsbyAmount = new SalesTotalsbyAmountData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.SalesTotalsbyAmountService.getAll().subscribe(record => this.SalesTotalsbyAmountList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getSalesTotalsbyAmountByPaging();

		/*
		this.SalesTotalsbyAmountList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getSalesTotalsbyAmount() {
		this.SalesTotalsbyAmountService.getAll()
			.subscribe(data => this.SalesTotalsbyAmountList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on SalesTotalsbyAmountSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getSalesTotalsbyAmountByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getSalesTotalsbyAmountByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getSalesTotalsbyAmountByPaging();
	}
	
	// Get records by paging
	getSalesTotalsbyAmountByPaging() {
		this.SalesTotalsbyAmountService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.SalesTotalsbyAmountList=data.SalesTotalsbyAmountList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addSalesTotalsbyAmount() {
		this.SalesTotalsbyAmountService.addSalesTotalsbyAmountData(this.newSalesTotalsbyAmount).subscribe(record => console.log(record));
		this.getSalesTotalsbyAmount();
	}
  
	// Updates existing record
	updateSalesTotalsbyAmount() {
		this.SalesTotalsbyAmountService.updateSalesTotalsbyAmountData(this.selectedSalesTotalsbyAmount).subscribe(record => console.log(record));
		this.getSalesTotalsbyAmount();
	}

	// Deletes record with specified id
	deleteSalesTotalsbyAmount(id: string) {
		if (window.confirm('Are you sure you want to delete this SalesTotalsbyAmount?') == true)
		{
			this.SalesTotalsbyAmountService.deleteSalesTotalsbyAmount(id)
			.subscribe(data => this.getSalesTotalsbyAmount(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getSalesTotalsbyAmountByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getSalesTotalsbyAmountByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getSalesTotalsbyAmountByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getSalesTotalsbyAmountByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: SalesTotalsbyAmountData) {
		this.router.navigate(['/SalesTotalsbyAmount', item.SaleAmount]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: SalesTotalsbyAmountData) {
		this.router.navigate(['/SalesTotalsbyAmount/Details', item.SaleAmount]);
	}

	// Set record as selected
	SelectSalesTotalsbyAmount(item: SalesTotalsbyAmountData) {
		this.selectedSalesTotalsbyAmount = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: SalesTotalsbyAmountData) {
		return item.SaleAmount === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesTotalsbyAmount/SalesTotalsbyAmountList.component.ts